import { Link } from 'react-router-dom';
import { buttonClass } from '@/components/ui/Button';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useI18n } from '@/hooks/useI18n';

export function NotFoundPage() {
  const { t } = useI18n();
  useDocumentMeta(t.meta.noEncontrada);
  const n = t.comun.noEncontrada;

  return (
    <div style={{ flex: 1, padding: 'calc(var(--ilu-nav-height) + 6rem) 0 6rem' }}>
      <div className="ilu-container" style={{ textAlign: 'center' }}>
        <span className="ilu-eyebrow">{n.eyebrow}</span>
        <h1 className="ilu-section-title">{n.titulo}</h1>
        <p className="ilu-lead" style={{ margin: '0 auto 2rem' }}>
          {n.cuerpo}
        </p>
        <Link to="/" className={buttonClass({ variant: 'primary' })}>
          {n.volver}
        </Link>
      </div>
    </div>
  );
}
